/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-03 10:33:30
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import { Card, TextStyle, Stack, SkeletonDisplayText } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import HandPickedProductType from './hand-picked-product-type';
import NoSearchResult from '../no-search-result';
import { MANUAL_RECOMMENDATION_TAB_TYPE } from 'src/constants/recommendation';
import type { ManualRecommendationResponseType } from 'src/models/recommendation';

type Props = {
  searching: boolean,
  searchSuccess: boolean,
  manualRecommendations: ManualRecommendationResponseType[],
  manualDeleting: boolean,
  manualDeleteSuccess: boolean,
  onDelete: (recommendationId: string) => void
};

type ComposedProps = WithI18nProps & Props;

class SearchResult extends Component<ComposedProps> {
  render() {
    return <div className="BC-Page__ManualType__SearchResult">{this.renderContent()}</div>;
  }

  renderContent = () => {
    const {
      i18n,
      searching,
      searchSuccess,
      manualRecommendations,
      manualDeleting,
      manualDeleteSuccess,
      onDelete
    } = this.props;

    if (searching) {
      const rows = [];
      for (let i = 0; i < 5; i++) {
        rows.push([<SkeletonDisplayText size="small" key={i} />]);
      }
      return <div className="BC-Page__ManualType__SearchResult__Loading">{rows}</div>;
    }

    if (_.isEmpty(manualRecommendations) && !searching && searchSuccess) {
      return (
        <div className="BC-Page__ManualType__SearchResult__Empty">
          <Card.Section>
            <Stack vertical alignment="center" distribution="center">
              <NoSearchResult />
            </Stack>
          </Card.Section>
        </div>
      );
    }

    const manualRecommendationHandPicked = manualRecommendations.filter(
      item => item.recommendationType === MANUAL_RECOMMENDATION_TAB_TYPE.HAND_PICKED_PRODUCTS
    );

    if (!_.isEmpty(manualRecommendationHandPicked)) {
      return (
        <Card.Section>
          <div className="BC-Page__ManualType__SearchResult__Title">
            <TextStyle variation="strong">
              {i18n.translate(
                'AdminHTML.Recommendation.ManualRecommendation.ManualType.tab2_Title'
              )}
            </TextStyle>
          </div>
          <HandPickedProductType
            manualRecommendations={manualRecommendationHandPicked}
            manualDeleting={manualDeleting}
            manualDeleteSuccess={manualDeleteSuccess}
            onDelete={onDelete}
          />
        </Card.Section>
      );
    }

    return null;
  };
}

export default withI18n()(SearchResult);
